<template>
  <b-container class="pt-0 pb-5">
    <b-row v-if="loading" class="my-5">
      <b-col class="text-center" cols="12">
        <i class="fa fa-spinner fa-spin loading__icon" />
      </b-col>
    </b-row>

    <b-row v-else-if="subscription" class="mt-5">
      <b-col cols="12">
        <h2 class="st_color_main_light st_none-none-big text-center">
          您已訂閱此服務
        </h2>
        <h3 class="st_color_main_light st_none-none-big text-center">
          【{{ channel.title }}】
        </h3>
        <div class="mt-5 text-center">
          <b-link
            :to="
              $userRoute({
                name: 'u-uid-service-articles',
                query: {
                  channel: channel.identity,
                },
              })
            "
            class="btn st_sub_m st_none-medium-big">
            前往查看付費觀點
          </b-link>
        </div>
      </b-col>
    </b-row>

    <b-row
      v-else-if="
        channel &&
          (!channel.enabled ||
            (singleSubscribe === 'expired' && $moment().valueOf() > channel.expired) ||
            channel.offShelf)
      "
      class="mt-5">
      <b-col cols="12">
        <h2 class="st_color_main_light st_none-none-big text-center">
          此服務已停止訂閱
        </h2>
        <h3 class="st_color_main_light st_none-none-big text-center">
          【{{ channel.title }}】
        </h3>
        <div class="mt-5 text-center">
          <b-link :to="$userRoute({ name: 'u-uid-service' })" class="btn st_sub_m st_none-medium-big">
            前往查看達人服務
          </b-link>
        </div>
      </b-col>
    </b-row>

    <b-row v-else-if="channel && channel.published > $moment().valueOf()" class="mt-5">
      <b-col cols="12">
        <h2 class="st_color_main_light st_none-none-big text-center">
          此服務尚未開放訂閱
        </h2>
        <h3 class="st_color_main_light st_none-none-big text-center">
          【{{ channel.title }}】
        </h3>
        <div class="mt-5 text-center">
          <b-link :to="$userRoute({ name: 'u-uid-service' })" class="btn st_sub_m st_none-medium-big">
            前往查看達人服務
          </b-link>
        </div>
      </b-col>
    </b-row>

    <b-row v-else-if="channel && channel.maximum !== -1 && channel.subscriptions >= channel.maximum" class="mt-5">
      <b-col cols="12">
        <h2 class="st_color_main_light st_none-none-big text-center">
          此服務訂閱已額滿
        </h2>
        <h3 class="st_color_main_light st_none-none-big text-center">
          【{{ channel.title }}】
        </h3>
        <div class="mt-5 text-center">
          <b-link :to="$userRoute({ name: 'u-uid-service' })" class="btn st_sub_m st_none-medium-big">
            前往查看達人服務
          </b-link>
        </div>
      </b-col>
    </b-row>

    <b-row v-else-if="channel && channel.outsideUrl" class="mt-5">
      <b-col cols="12">
        <h2 class="st_color_main_light st_none-none-big text-center">
          請點擊下方按鈕前往訂閱
        </h2>
        <h3 class="st_color_main_light st_none-none-big text-center">
          【{{ channel.title }}】
        </h3>
        <div class="mt-5 text-center">
          <b-link :href="channel.outsideUrl" class="btn st_gold_m">
            <i class="fas fa-external-link-alt pr-1" />
            立即訂閱
          </b-link>
        </div>
      </b-col>
    </b-row>

    <b-row v-else>
      <b-container fluid>
        <div class="purchaseInfo">
          <h2
            class="st_background_white st_title-medium-big st-md_title-medium-biggest text-center purchaseInfo__title">
            1.確認訂單資訊
          </h2>
          <div class="purchaseInfo__detail">
            <CartItemCard :channel="channel" />
          </div>
        </div>

        <b-row v-if="$userCheck.isLogin() && channel">
          <b-container fluid>
            <!-- 以下為原本mobile的dom加以修改做rwd -->
            <b-row class="justify-content-center">
              <b-col class="st_background_white pt-4 pt-md-5 px-0" lg="10">
                <b-container fluid>
                  <!-- desktop -->
                  <b-row class="mb-5 d-none d-lg-block">
                    <b-col>
                      <h2 class="st_color_main_light st_title-medium-biggest text-center">
                        2.選擇付款方式
                      </h2>
                    </b-col>
                  </b-row>

                  <b-row
                    v-if="channel.trial.time > 0"
                    :class="{
                      active: trial && payType === 'PREAPPROVED' && canTrial,
                      disabled: payType !== 'PREAPPROVED' || canTrial === false,
                    }"
                    class="trial-subscription-mobile mb-4 justify-content-center">
                    <!-- mobile -->
                    <b-col class="d-lg-none" cols="12">
                      <div class="border border-width-2px rounded block">
                        <div class="title text-center py-1">
                          <md-checkbox
                            v-model="trial"
                            :disabled="payType !== 'PREAPPROVED' || canTrial === false"
                            class="st-checkbox reverse">
                            <span class="title-text trial__text--base"> 申請免費試閱 </span>
                          </md-checkbox>
                        </div>

                        <h5 class="des st_color_gray_dark trial__text--small text-center p-3">
                          免費試閱 {{ channel.trial.time }} 天，到期後系統將自動扣款並續訂
                          <div class="des-notice w-100 st_color_white trial__text--base">
                            <div
                              v-if="canTrial && payType !== 'PREAPPROVED'"
                              class="d-flex justify-content-center align-items-center">
                              <span>付款方式請選擇</span>
                              <div class="d-flex align-items-center">
                                <svg-icon :height="20" :width="69" class="mr-2 ml-4" name="icon_linepay" />
                                <span>或 信用卡</span>
                              </div>
                            </div>
                            <div v-if="canTrial === false">
                              您已經對這個服務項目<br>
                              申請過一次免費試閱
                            </div>
                          </div>
                        </h5>

                        <div class="px-3 pb-2 pt-1">
                          <div class="text-center">
                            <b-link
                              class="st_color_main_lightest mr-2"
                              @click.prevent="free.onShowDetail = !free.onShowDetail">
                              <span> 試閱說明 </span>
                              <i
                                :class="free.onShowDetail ? 'fa-caret-up' : 'fa-caret-down'"
                                class="fas st_color_gray_light trial__text--smaller" />
                            </b-link>
                          </div>

                          <div v-if="free.onShowDetail" class="mt-3">
                            <h6 class="st_color_gray_dark trial__text--small mb-1">
                              請注意：
                            </h6>
                            <h6 class="st_color_gray_dark trial__text--small mb-1">
                              1. 申請免費試閱需綁定 LINE Pay 或 信用卡
                            </h6>
                            <h6 class="st_color_warning trial__text--small mb-1">
                              2. 系統預設會在試閱到期日自動扣款並續訂
                            </h6>
                            <h6 class="st_color_gray_dark trial__text--small mb-1">
                              3. 若您不繼續訂閱，請自行在試閱到期前一日至「訂單記錄」頁面取消訂閱
                            </h6>
                          </div>
                        </div>
                      </div>
                    </b-col>

                    <!-- desktop -->
                    <b-col class="d-none d-lg-flex mb-2" cols="10">
                      <b-row
                        :class="{
                          active: trial && payType === 'PREAPPROVED' && canTrial,
                          disabled: payType !== 'PREAPPROVED' || canTrial === false,
                        }"
                        class="trial-subscription">
                        <b-col cols="auto">
                          <div class="border border-width-2px block rounded text-center px-4 py-3 max-width-265px">
                            <md-checkbox
                              v-model="trial"
                              :disabled="payType !== 'PREAPPROVED' || canTrial === false"
                              class="st-checkbox mb-3">
                              <span class="title-text trial__text--bigger"> 申請免費試閱 </span>
                            </md-checkbox>
                            <h5 class="st_color_gray_dark des-text trial__text--small line-height-1_2rem">
                              免費試閱 {{ channel.trial.time }} 天，到期後系統將自動扣款並續訂
                            </h5>
                            <div class="notice rounded st_color_white trial__text--small">
                              <div
                                v-if="canTrial && payType !== 'PREAPPROVED'"
                                class="d-flex flex-column justify-content-center align-items-center">
                                <span class="mb-2">付款方式請選擇</span>
                                <div class="d-flex align-items-center">
                                  <svg-icon :height="20" :width="69" class="mr-2" name="icon_linepay" />
                                  <span>或 信用卡</span>
                                </div>
                              </div>
                              <div v-if="canTrial === false">
                                您已經對這個服務項目<br>
                                申請過一次免費試閱
                              </div>
                            </div>
                          </div>
                        </b-col>

                        <b-col class="d-flex align-items-center">
                          <div>
                            <h6 class="st_color_gray_dark trial__text--small mb-1">
                              請注意：
                            </h6>
                            <h6 class="st_color_gray_dark trial__text--small mb-1">
                              1. 申請免費試閱需綁定 LINE Pay 或 信用卡
                            </h6>
                            <h6 class="st_color_warning trial__text--small mb-1">
                              2. 系統預設會在試閱到期日自動扣款並續訂
                            </h6>
                            <h6 class="st_color_gray_dark trial__text--small mb-1">
                              3. 若您不繼續訂閱，請自行在試閱到期前一日至「訂單記錄」頁面取消訂閱
                            </h6>
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-container fluid>
                      <b-row class="mb-3 d-lg-none">
                        <b-col cols="12">
                          <h2 class="st_color_main_light st_none-none-big text-center">
                            2.選擇付款資訊
                          </h2>
                        </b-col>
                      </b-row>

                      <b-row class="justify-content-center payChoose">
                        <b-col cols="12" lg="10">
                          <b-container class="border st_border_gray_lighter border-width-2px" fluid>
                            <b-row>
                              <b-col
                                class="st_background_gray_lighter payChoose__way__title d-flex align-items-center justify-content-center"
                                cols="12"
                                lg="3">
                                <h5 class="st_color_gray_darker payChoose__text--base py-2">
                                  付款方式
                                </h5>
                              </b-col>
                              <b-col class="py-3 py-lg-4" cols="12" lg="9">
                                <b-container class="px-0" fluid>
                                  <b-row class="mb-2">
                                    <b-col class="pr-0">
                                      <md-radio
                                        v-model="pay"
                                        :disabled="checkPayDisable('LINEPAY/PREAPPROVED')"
                                        class="st_radio mx-0"
                                        value="LINEPAY/PREAPPROVED">
                                        <svg-icon :height="20" :width="69" class="mb-1" name="icon_linepay" />
                                        <span class="st_color_gray_light payChoose__text--small ml-2"> 免手續費 </span>
                                      </md-radio>
                                    </b-col>
                                    <b-col class="text-right pl-0" cols="auto">
                                      <b-link
                                        class="st_color_link payChoose__text--smaller"
                                        href="http://official-blog.line.me/tw/archives/39016757.html"
                                        target="_blank">
                                        綁定教學
                                      </b-link>
                                    </b-col>
                                  </b-row>

                                  <b-row class="mb-2">
                                    <b-col>
                                      <md-radio
                                        v-model="pay"
                                        :disabled="checkPayDisable('TAPPAY/PREAPPROVED')"
                                        class="st_radio st_color_gray_darker mx-0"
                                        value="TAPPAY/PREAPPROVED">
                                        信用卡
                                        <span class="st_color_gray_light payChoose__text--small ml-2"> 免手續費 </span>
                                      </md-radio>
                                    </b-col>
                                  </b-row>

                                  <b-row class="mb-2">
                                    <b-col>
                                      <md-radio
                                        v-model="pay"
                                        :disabled="checkPayDisable('ECPAY/ATM')"
                                        class="st_radio st_color_gray_darker mx-0"
                                        value="ECPAY/ATM">
                                        ATM 付款
                                        <span class="st_color_gray_light payChoose__text--small ml-2">
                                          手續費 5~26 元
                                          <span id="question-mark-atm-mobile" class="question-mark"> ? </span>
                                        </span>
                                      </md-radio>

                                      <b-tooltip target="question-mark-atm-mobile">
                                        ATM繳費需收取付款金額 1% 手續費， 最低5元；最高26元。
                                        且此手續費將不列入退費受理範圍。
                                      </b-tooltip>
                                    </b-col>
                                  </b-row>

                                  <b-row class="mb-1">
                                    <b-col>
                                      <md-radio
                                        v-model="pay"
                                        :disabled="checkPayDisable('ECPAY/CVS')"
                                        class="st_radio st_color_gray_darker mx-0"
                                        value="ECPAY/CVS">
                                        超商付款
                                        <span class="st_color_gray_light payChoose__text--small ml-2">
                                          手續費 30 元
                                          <span id="question-mark-cvs-mobile" class="question-mark"> ? </span>
                                        </span>
                                      </md-radio>

                                      <b-tooltip target="question-mark-cvs-mobile">
                                        超商代碼繳費需收取 30 元手續費， 且此手續費將不列入退費受理範圍。
                                      </b-tooltip>
                                    </b-col>
                                  </b-row>
                                </b-container>
                              </b-col>
                            </b-row>

                            <b-row
                              v-if="pay === 'LINEPAY/PREAPPROVED' && cardListLinePay && cardListLinePay.length"
                              class="st_border_gray_lighter creditCard__block py-3 py-lg-4">
                              <b-col class="creditCard__select px-0" cols="12">
                                <b-col class="mb-3" cols="12">
                                  <md-radio v-model="useNewCard" :value="false" class="st_radio mx-0">
                                    我的 LINE Pay 卡
                                  </md-radio>
                                </b-col>
                                <b-col v-if="!useNewCard" class="mx-auto" lg="11">
                                  <multiselect
                                    v-model="paymentCard"
                                    :allowEmpty="false"
                                    :disabled="!cardListLinePay.length"
                                    :options="cardListLinePay"
                                    :searchable="false"
                                    :showLabels="false"
                                    openDirection="bottom"
                                    placeholder="請選擇卡片"
                                    trackBy="id">
                                    <template slot="singleLabel" slot-scope="props">
                                      <b-row class="ml-0 align-items-center">
                                        <b-col class="ml-1 px-0 d-flex">
                                          <svg-icon
                                            :name="`icon_card_${getCardType(props.option.type)}`"
                                            class="card__icon"
                                            height="20"
                                            width="30" />
                                          <span
                                            :class="
                                              !props.option.name || props.option.name === ''
                                                ? 'st_color_gray_light'
                                                : 'st_color_main'
                                            "
                                            class="text-overflow-1-line">
                                            {{ props.option.name ? props.option.name : '未命名' }}
                                          </span>
                                        </b-col>
                                        <b-col class="ml-auto mr-4 px-0" cols="auto">
                                          <span class="d-md-none"> ... </span>
                                          <span class="d-none d-md-inline"> ****-****- </span>
                                          ****-{{ props.option.lastFour }}
                                        </b-col>
                                      </b-row>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                      <b-row class="ml-0 align-items-center">
                                        <b-col class="ml-1 px-0 d-flex">
                                          <svg-icon
                                            :name="`icon_card_${getCardType(props.option.type)}`"
                                            class="card__icon"
                                            height="20"
                                            width="30" />
                                          <span
                                            :class="
                                              !props.option.name || props.option.name === ''
                                                ? 'st_color_gray_light'
                                                : 'st_color_main'
                                            "
                                            class="text-overflow-1-line">
                                            {{ props.option.name ? props.option.name : '未命名' }}
                                          </span>
                                        </b-col>
                                        <b-col class="ml-auto mr-4 px-0" cols="auto">
                                          <span class="d-md-none"> ... </span>
                                          <span class="d-none d-md-inline"> ****-****- </span>
                                          ****-{{ props.option.lastFour }}
                                        </b-col>
                                      </b-row>
                                    </template>
                                  </multiselect>
                                </b-col>
                                <b-col class="mt-3" cols="12">
                                  <md-radio v-model="useNewCard" :value="true" class="st_radio mx-0">
                                    {{ !singleSubscribe ? '授權' : '使用' }}新的 LINE Pay 卡
                                    {{ !singleSubscribe ? '' : '或一卡通帳戶' }}
                                  </md-radio>
                                </b-col>
                              </b-col>
                            </b-row>

                            <b-row
                              v-if="pay === 'TAPPAY/PREAPPROVED'"
                              class="st_border_gray_lighter creditCard__block py-3 py-lg-4">
                              <b-col
                                v-if="cardListTapPay && cardListTapPay.length"
                                class="creditCard__select px-0"
                                cols="12">
                                <b-col class="mb-3" cols="12">
                                  <md-radio v-model="useNewCard" :value="false" class="st_radio mx-0">
                                    我的信用卡
                                  </md-radio>
                                </b-col>
                                <b-col v-if="!useNewCard" class="mx-auto" lg="11">
                                  <multiselect
                                    v-model="paymentCard"
                                    :allowEmpty="false"
                                    :disabled="!cardListTapPay.length"
                                    :options="cardListTapPay"
                                    :searchable="false"
                                    :showLabels="false"
                                    openDirection="bottom"
                                    placeholder="請選擇卡片"
                                    trackBy="id">
                                    <template slot="singleLabel" slot-scope="props">
                                      <b-row class="ml-0 align-items-center">
                                        <b-col class="ml-1 px-0 d-flex">
                                          <svg-icon
                                            :name="`icon_card_${getCardType(props.option.type)}`"
                                            class="card__icon"
                                            height="20"
                                            width="30" />
                                          <span
                                            :class="
                                              !props.option.name || props.option.name === ''
                                                ? 'st_color_gray_light'
                                                : 'st_color_main'
                                            "
                                            class="text-overflow-1-line">
                                            {{ props.option.name ? props.option.name : '未命名' }}
                                          </span>
                                        </b-col>
                                        <b-col class="ml-auto mr-4 px-0" cols="auto">
                                          <span class="d-md-none"> ... </span>
                                          <span class="d-none d-md-inline"> ****-****- </span>
                                          ****-{{ props.option.lastFour }}
                                        </b-col>
                                      </b-row>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                      <b-row class="ml-0 align-items-center">
                                        <b-col class="ml-1 px-0 d-flex">
                                          <svg-icon
                                            :name="`icon_card_${getCardType(props.option.type)}`"
                                            class="card__icon"
                                            height="20"
                                            width="30" />
                                          <span
                                            :class="
                                              !props.option.name || props.option.name === ''
                                                ? 'st_color_gray_light'
                                                : 'st_color_main'
                                            "
                                            class="text-overflow-1-line">
                                            {{ props.option.name ? props.option.name : '未命名' }}
                                          </span>
                                        </b-col>
                                        <b-col class="ml-auto mr-4 px-0" cols="auto">
                                          <span class="d-md-none"> ... </span>
                                          <span class="d-none d-md-inline"> ****-****- </span>
                                          ****-{{ props.option.lastFour }}
                                        </b-col>
                                      </b-row>
                                    </template>
                                  </multiselect>
                                </b-col>
                                <b-col class="mt-3" cols="12">
                                  <md-radio v-model="useNewCard" :value="true" class="st_radio mx-0">
                                    使用其他信用卡
                                  </md-radio>
                                </b-col>
                              </b-col>
                              <b-col v-if="useNewCard" class="creditCard__newCard px-3 px-lg-0 mt-3" cols="12">
                                <b-col class="creditCard__inside creditCard__inside__top mx-auto mb-4" cols="12">
                                  <b-row class="creditCard__numberLabel pb-3">
                                    <b-col class="st_color_main_light px-0">
                                      信用卡卡號
                                    </b-col>
                                    <b-col class="text-right px-0">
                                      <svg-icon height="20" name="icon_card_visa" width="30" />
                                      <svg-icon height="20" name="icon_card_master" width="30" />
                                      <svg-icon height="20" name="icon_card_jcb" width="30" />
                                      <svg-icon v-if="false" height="20" name="icon_card_amex" width="30" />
                                    </b-col>
                                  </b-row>
                                  <b-row
                                    :class="`creditCard__state--${cardNumberState}`"
                                    class="creditCard__number px-3 py-2">
                                    <b-col class="px-0" cols="auto">
                                      <svg-icon
                                        :name="`icon_card_${card.type}`"
                                        class="creditCard__number__icon"
                                        height="20"
                                        width="30" />
                                    </b-col>
                                    <b-col class="px-0">
                                      <input
                                        v-model="card.number"
                                        :maxLength="card.type === 'amex' ? 17 : 19"
                                        class="creditCard__input creditCard__number__input"
                                        placeholder="0000-0000-0000-0000">
                                    </b-col>
                                  </b-row>
                                </b-col>
                                <b-col class="creditCard__inside creditCard__inside__bottom mx-auto mb-1" cols="12">
                                  <b-row>
                                    <b-col class="pl-0 pr-2" cols="6" md="5">
                                      <b-col class="st_color_main_light px-0 mb-2">
                                        有效期限
                                      </b-col>
                                      <b-col
                                        :class="`creditCard__state--${cardExpiryState}`"
                                        class="px-0 creditCard__expiry">
                                        <input
                                          v-model="card.expiry"
                                          class="creditCard__input creditCard__expiry__input"
                                          maxLength="5"
                                          placeholder="月/年">
                                      </b-col>
                                    </b-col>
                                    <b-col class="px-0" cols="6" md="5" offset-md="2">
                                      <b-col class="st_color_main_light px-0 mb-2">
                                        卡片末{{ card.type === 'amex' ? '四' : '三' }}碼
                                      </b-col>
                                      <b-col :class="`creditCard__state--${cardCcvState}`" class="px-0 creditCard__ccv">
                                        <input
                                          v-model="card.ccv"
                                          :maxLength="card.type === 'amex' ? 4 : 3"
                                          :placeholder="card.type === 'amex' ? '1234' : '123'"
                                          class="creditCard__input creditCard__ccv__input">
                                      </b-col>
                                    </b-col>
                                  </b-row>
                                </b-col>
                              </b-col>
                            </b-row>

                            <b-row class="payChoose__period payment--border">
                              <b-col
                                class="st_background_gray_lighter d-flex payChoose__period__title align-items-center justify-content-center"
                                cols="12"
                                lg="3">
                                <h5 class="st_color_gray_darker payChoose__text--base py-2">
                                  訂閱期限
                                  <span id="question-mark-period-mobile" class="question-mark"> ? </span>
                                </h5>
                                <b-tooltip target="question-mark-period-mobile">
                                  訂閱期限是指您付費服務的有效期限。訂閱到期後需要重新付款訂閱。
                                </b-tooltip>
                              </b-col>
                              <b-col class="py-2 my-1" cols="12" lg="9">
                                <template v-if="singleSubscribe === 'expired'">
                                  <md-radio v-model="month" :disabled="true" :value="1" class="st_radio mx-0">
                                    單次購買({{ $moment(channel.expired).format('YYYY-MM-DD') }}到期)
                                  </md-radio>
                                </template>
                                <template v-else>
                                  <md-radio
                                    v-show="payType === 'PREAPPROVED'"
                                    v-model="month"
                                    :disabled="true"
                                    :value="channel.autoRenewal"
                                    class="st_radio mx-0">
                                    {{
                                      singleSubscribe === 'month' ? '單次購買' : '自動續訂'
                                    }}{{ channel.autoRenewal > 1 ? `${channel.autoRenewal}個月` : '' }}
                                    <span
                                      v-if="!channel.convertAutoRenewalToSingle"
                                      id="question-mark-auto-mobile"
                                      class="question-mark">
                                      ?
                                    </span>
                                  </md-radio>

                                  <b-tooltip target="question-mark-auto-mobile">
                                    每{{
                                      channel.autoRenewal > 1 ? channel.autoRenewal : ''
                                    }}個月訂閱到期時，系統將使用您的{{
                                      payment === 'LINEPAY' ? 'LINE Pay' : '信用卡'
                                    }}自動訂閱並扣款。
                                  </b-tooltip>

                                  <md-radio
                                    v-if="payment === 'ECPAY'"
                                    v-model="month"
                                    :disabled="checkMonthDisable(1)"
                                    :value="1"
                                    class="st_radio ml-0 mr-3">
                                    1 {{ channel.unitWord && channel.unitWord !== '' ? channel.unitWord : '個月' }}
                                    <md-tooltip v-if="checkMonthDisablePrice(1)">
                                      超商代碼付款總金額不得超過20,000元
                                    </md-tooltip>
                                  </md-radio>
                                  <md-radio
                                    v-if="payment === 'ECPAY'"
                                    v-model="month"
                                    :disabled="checkMonthDisable(3)"
                                    :value="3"
                                    class="st_radio ml-0 mr-3">
                                    3 {{ channel.unitWord && channel.unitWord !== '' ? channel.unitWord : '個月' }}
                                    <md-tooltip v-if="checkMonthDisablePrice(3)">
                                      超商代碼付款總金額不得超過20,000元
                                    </md-tooltip>
                                  </md-radio>
                                  <md-radio
                                    v-if="payment === 'ECPAY'"
                                    v-model="month"
                                    :disabled="checkMonthDisable(6)"
                                    :value="6"
                                    class="st_radio ml-0 mr-3">
                                    6 {{ channel.unitWord && channel.unitWord !== '' ? channel.unitWord : '個月' }}
                                    <md-tooltip v-if="checkMonthDisablePrice(6)">
                                      超商代碼付款總金額不得超過20,000元
                                    </md-tooltip>
                                  </md-radio>
                                  <md-radio
                                    v-if="payment === 'ECPAY'"
                                    v-model="month"
                                    :disabled="checkMonthDisable(12)"
                                    :value="12"
                                    class="st_radio mx-0">
                                    12 {{ channel.unitWord && channel.unitWord !== '' ? channel.unitWord : '個月' }}
                                    <md-tooltip v-if="checkMonthDisablePrice(12)">
                                      超商代碼付款總金額不得超過20,000元
                                    </md-tooltip>
                                  </md-radio>
                                </template>
                              </b-col>
                            </b-row>

                            <b-row class="payChoose__coupon">
                              <b-col
                                class="st_background_gray_lighter payChoose__coupon__title d-flex align-items-center justify-content-center"
                                cols="12"
                                lg="3">
                                <h5 class="st_color_gray_darker payChoose__text--base py-2">
                                  使用優惠券
                                </h5>
                              </b-col>

                              <b-col class="py-2" cols="12" lg="9">
                                <div class="d-flex justify-content-between align-items-center payChoose__coupon__input">
                                  <Input
                                    v-model="couponInput"
                                    :disabled="couponDisabled"
                                    :feedback="couponFeedback"
                                    :placeholder="couponPlaceholder"
                                    :status="couponState"
                                    class="d-inline-block max-width-265px my-0"
                                    inputClass="st_border_gray_lighter coupon__input--width"
                                    type="text" />
                                  <b-button
                                    :disabled="couponButtonDisabled"
                                    class="st_sub_s ml-2"
                                    @click.prevent="checkCoupon">
                                    兌換
                                  </b-button>
                                </div>
                              </b-col>
                              <CouponAnniversary :anniversaryIdentity="anniversaryIdentity" />
                              <b-col v-if="couponList && couponList.length" class="pb-3" cols="12" lg="9" offset-lg="3">
                                <b-container class="border rounded st_color_gray_lighter" fluid>
                                  <b-row v-for="(couponItem, index) in couponList" :key="index" class="py-2">
                                    <b-col class="pr-0" cols="auto">
                                      <div>
                                        <i class="fas fa-ticket-alt st_color_coupon coupon__icon" />
                                      </div>
                                    </b-col>
                                    <b-col class="pr-0">
                                      <div class="mb-2 d-lg-flex flex-wrap">
                                        <h5 class="st_color_gray_darker payChoose__text--base mr-lg-2 mb-1 mb-lg-0">
                                          {{ couponItem.title }}
                                        </h5>
                                        <h5 class="st_color_gray_darker payChoose__text--base">
                                          ({{
                                            couponList[0].discount.calculationMethod === 'firstMonth'
                                              ? '首' +
                                                (channel.unitWord && channel.unitWord !== '' ? channel.unitWord : '月')
                                              : couponList[0].discount.calculationMethod === 'allMonths'
                                                ? '每' +
                                                  (channel.unitWord && channel.unitWord !== '' ? channel.unitWord : '月')
                                                : ''
                                          }}{{
                                            couponItem.discount.type === 'trial'
                                              ? `免費 ${couponItem.discount.value} 天`
                                              : couponItem.discount.type === 'percent'
                                                ? `折扣 ${couponItem.discount.value}%`
                                                : `折扣 $${couponItem.discount.value}`
                                          }})
                                        </h5>
                                      </div>
                                      <h6 class="st_color_gray_dark payChoose__text--small">
                                        {{ couponItem.code.toUpperCase() }}
                                      </h6>
                                    </b-col>
                                    <b-col class="d-flex align-items-center" cols="auto">
                                      <b-button
                                        class="st_background_transparent p-0"
                                        variant="none"
                                        @click.prevent="removeCoupon(couponItem.code)">
                                        <i class="fas fa-times-circle st_color_gray_light st_none-none-biggest" />
                                      </b-button>
                                    </b-col>
                                  </b-row>
                                </b-container>
                              </b-col>
                            </b-row>

                            <b-row class="payChoose__amount">
                              <b-col
                                class="st_background_gray_lighter payChoose__amount__title d-flex align-items-center justify-content-center"
                                cols="12"
                                lg="3">
                                <h5 class="st_color_gray_darker payChoose__text--base py-2 py-lg-3">
                                  付款金額
                                </h5>
                              </b-col>

                              <b-col class="mb-3 py-2" cols="12">
                                <b-container class="px-0" fluid>
                                  <b-row>
                                    <b-col cols="12" lg="10" offset-lg="1">
                                      <b-container v-if="payType === 'PREAPPROVED'" class="px-0" fluid>
                                        <!-- 優惠券折抵 -->
                                        <b-row
                                          v-if="
                                            couponList &&
                                              couponList.length &&
                                              couponList[0].discount.calculationMethod !== 'allMonths' &&
                                              (!singleSubscribe ||
                                                (couponList[0].discount.calculationMethod === 'firstMonth' &&
                                                  singleSubscribe === 'month'))
                                          "
                                          class="align-items-lg-center py-3 py-lg-0">
                                          <b-col class="text-center text-lg-left">
                                            <h5 class="st_color_gray_dark st_none-none-base">
                                              {{
                                                couponList[0].discount.type === 'trial'
                                                  ? `${couponList[0].discount.value} 天`
                                                  : '首' +
                                                    (channel.unitWord && channel.unitWord !== ''
                                                      ? channel.unitWord
                                                      : '月')
                                              }}
                                            </h5>
                                          </b-col>
                                          <b-col class="pl-0" cols="9">
                                            <b-container class="px-0" fluid>
                                              <b-row class="flex-lg-row-reverse align-items-center">
                                                <b-col class="text-lg-right mb-2 mb-lg-0" cols="12" lg="6">
                                                  <h5 class="st_color_gray_darker">
                                                    <span class="payChoose__amount__version_1__dollarsign">$</span><span
                                                      class="payChoose__amount__version_1__price">{{
                                                      couponList[0].discount.type === 'trial' && discountTrial
                                                        ? discountTrial.price
                                                        : discountedPrice
                                                    }}</span>
                                                    <span class="st_none-none-base">新台幣</span>
                                                  </h5>
                                                </b-col>
                                                <b-col cols="12" lg="6">
                                                  <h5
                                                    class="st_color_coupon st_none-medium-base d-flex align-items-center">
                                                    <span
                                                      v-if="couponList[0].discount.calculationMethod === 'firstMonth'"
                                                      class="coupon__state mr-1">首{{
                                                        channel.unitWord && channel.unitWord !== ''
                                                          ? channel.unitWord
                                                          : '月'
                                                      }}</span>
                                                    <span>
                                                      {{
                                                        couponList[0].discount.type === 'trial'
                                                          ? '優惠券免費訂閱'
                                                          : couponList[0].discount.type === 'percent'
                                                            ? `優惠券折抵 ${couponList[0].discount.value}%`
                                                            : `優惠券折抵 $${couponList[0].discount.value}`
                                                      }}
                                                    </span>
                                                  </h5>
                                                  <h6
                                                    v-if="
                                                      couponList[0].discount.type === 'trial' &&
                                                        discountTrial &&
                                                        discountTrial.time > 0
                                                    "
                                                    class="st_color_gray st_none-none-small mt-2">
                                                    到期日
                                                    {{ $moment().add(discountTrial.time, 'days').format('YYYY/MM/DD') }}
                                                  </h6>
                                                </b-col>
                                              </b-row>
                                            </b-container>
                                          </b-col>
                                        </b-row>
                                        <!-- 免費試閱 -->
                                        <b-row
                                          v-if="trial && canTrial && _.get(channel, 'trial.time', 0) > 0"
                                          class="align-items-lg-center py-3 py-lg-0">
                                          <b-col class="text-center text-lg-left">
                                            <h5 class="st_color_gray_dark st_none-none-base">
                                              {{ channel.trial.time }} 天
                                            </h5>
                                          </b-col>
                                          <b-col class="pl-0" cols="9">
                                            <b-container class="px-0" fluid>
                                              <b-row class="flex-lg-row-reverse align-items-center">
                                                <b-col class="text-lg-right mb-2 mb-lg-0" cols="12" lg="6">
                                                  <h5 class="st_color_gray_darker">
                                                    <span class="payChoose__amount__version_1__dollarsign">$</span><span
                                                      class="payChoose__amount__version_1__price">{{
                                                      channel.trial.price
                                                    }}</span>
                                                    <span class="st_none-none-base">新台幣</span>
                                                  </h5>
                                                </b-col>
                                                <b-col cols="12" lg="6">
                                                  <h5 class="st_color_gray_darker st_none-medium-base mb-2">
                                                    免費試閱
                                                  </h5>
                                                  <h6 class="st_color_gray st_none-none-small">
                                                    試閱到期日
                                                    {{ $moment().add(channel.trial.time, 'days').format('YYYY/MM/DD') }}
                                                  </h6>
                                                </b-col>
                                              </b-row>
                                            </b-container>
                                          </b-col>
                                        </b-row>

                                        <hr
                                          v-if="
                                            (couponList &&
                                              couponList.length &&
                                              couponList[0].discount.calculationMethod !== 'allMonths' &&
                                              (!singleSubscribe ||
                                                (couponList[0].discount.calculationMethod === 'firstMonth' &&
                                                  singleSubscribe === 'month'))) ||
                                              (trial && canTrial && channel.trial.time > 0)
                                          "
                                          class="coupon__border--mobile border-bottom st_border_gray_lighter my-3">

                                        <!-- 每月 -->
                                        <b-row
                                          :class="{
                                            'align-items-center':
                                              couponList &&
                                              couponList.length &&
                                              couponList[0].discount.calculationMethod === 'allMonths',
                                          }"
                                          class="align-items-lg-center py-3 py-lg-0">
                                          <b-col class="text-center text-lg-left" cols="auto" sm="3">
                                            <h5 class="st_color_gray_dark st_none-none-base">
                                              <template
                                                v-if="
                                                  (singleSubscribe === 'expired' && payType === 'PREAPPROVED') ||
                                                    channel.autoRenewal === -1
                                                ">
                                                單次購買
                                              </template>
                                              <template v-else>
                                                每{{
                                                  channel.autoRenewal === 1 && singleSubscribe !== 'month' ? '個' : ''
                                                }}{{
                                                  convertAutoRenewal(
                                                    channel.autoRenewal,
                                                    channel.convertAutoRenewalToSingle,
                                                  )
                                                }}
                                              </template>
                                            </h5>
                                          </b-col>
                                          <b-col class="pl-0">
                                            <b-container class="px-0" fluid>
                                              <b-row class="flex-lg-row-reverse align-items-center">
                                                <b-col class="text-lg-right mb-2 mb-lg-0" cols="12" lg="auto">
                                                  <h5 class="st_color_gray_darker">
                                                    <span
                                                      :class="
                                                        couponList &&
                                                          couponList.length &&
                                                          (couponList[0].discount.calculationMethod === 'allMonths' ||
                                                            !(
                                                              couponList[0].discount.calculationMethod !== 'allMonths' &&
                                                              singleSubscribe === 'month'
                                                            ))
                                                          ? 'payChoose__amount__version_2__dollarsign'
                                                          : 'payChoose__amount__version_1__dollarsign'
                                                      ">$</span><span
                                                      :class="
                                                        couponList &&
                                                          couponList.length &&
                                                          (couponList[0].discount.calculationMethod === 'allMonths' ||
                                                            !(
                                                              couponList[0].discount.calculationMethod !== 'allMonths' &&
                                                              singleSubscribe === 'month'
                                                            ))
                                                          ? 'payChoose__amount__version_2__price'
                                                          : 'payChoose__amount__version_1__price'
                                                      ">{{
                                                      couponList &&
                                                        couponList.length &&
                                                        (couponList[0].discount.calculationMethod === 'allMonths' ||
                                                          (couponList[0].discount.calculationMethod !== 'allMonths' &&
                                                            singleSubscribe === 'month') ||
                                                          (couponList[0].discount.calculationMethod === 'thisOrder' &&
                                                            singleSubscribe === 'expired'))
                                                        ? discountPayPrice
                                                        : payPrice
                                                    }}</span>
                                                    <span
                                                      class="st_none-none-base">新台幣 /
                                                      {{
                                                        convertAutoRenewal(
                                                          channel.autoRenewal,
                                                          channel.convertAutoRenewalToSingle,
                                                        )
                                                      }}</span>
                                                  </h5>
                                                </b-col>
                                                <b-col cols="12" lg>
                                                  <template v-if="!singleSubscribe">
                                                    <h5
                                                      v-if="
                                                        couponList &&
                                                          couponList.length &&
                                                          couponList[0].discount.calculationMethod === 'allMonths'
                                                      "
                                                      class="st_color_coupon st_none-medium-base d-flex align-items-center mb-2">
                                                      <span
                                                        class="coupon__state">每{{
                                                          channel.unitWord && channel.unitWord !== ''
                                                            ? channel.unitWord
                                                            : '月'
                                                        }}</span>
                                                      <span class="ml-1">
                                                        {{
                                                          couponList[0].discount.type === 'trial'
                                                            ? '優惠券免費訂閱'
                                                            : couponList[0].discount.type === 'percent'
                                                              ? `優惠券折抵 ${couponList[0].discount.value}%`
                                                              : `優惠券折抵 $${couponList[0].discount.value}`
                                                        }}
                                                      </span>
                                                    </h5>
                                                    <div
                                                      :class="{
                                                        'd-lg-block': !(
                                                          couponList &&
                                                          couponList.length &&
                                                          couponList[0].discount.calculationMethod === 'allMonths'
                                                        ),
                                                      }"
                                                      class="d-flex flex-wrap align-items-center">
                                                      <h5
                                                        :class="{
                                                          'mb-lg-2': !(
                                                            couponList &&
                                                            couponList.length &&
                                                            couponList[0].discount.calculationMethod === 'allMonths'
                                                          ),
                                                        }"
                                                        class="st_color_gray_darker st_none-medium-base mr-2">
                                                        自動續訂
                                                      </h5>
                                                      <h6
                                                        v-if="
                                                          (trial && canTrial && channel.trial.time > 0) ||
                                                            (couponList &&
                                                              couponList.length &&
                                                              couponList[0].discount.type === 'trial' &&
                                                              couponList[0].discount.value > 0)
                                                        "
                                                        class="st_color_gray st_none-none-small">
                                                        於
                                                        {{
                                                          $moment()
                                                            .add(
                                                              discountTrial && discountTrial.time > 0
                                                                ? discountTrial.time
                                                                : channel.trial.time,
                                                              'days',
                                                            )
                                                            .add(1, 'day')
                                                            .format('YYYY/MM/DD')
                                                        }}
                                                        開始自動扣款
                                                      </h6>
                                                      <h6 v-else class="st_color_gray st_none-none-small">
                                                        預計扣款日：每月{{ $moment().format('D') }}號
                                                      </h6>
                                                    </div>
                                                  </template>
                                                </b-col>
                                              </b-row>
                                            </b-container>
                                          </b-col>
                                        </b-row>
                                        <hr
                                          v-if="
                                            ((!couponList ||
                                              (couponList.length &&
                                                couponList[0].discount &&
                                                couponList[0].discount.calculationMethod === 'allMonths')) &&
                                              !(trial && canTrial && channel.trial.time > 0)) ||
                                              (couponList.length &&
                                                couponList[0].discount.calculationMethod === 'thisOrder' &&
                                                singleSubscribe === 'expired')
                                          "
                                          class="d-none d-lg-block border-bottom st_border_gray_lighter my-3">
                                        <b-row class="pb-3 pb-lg-0">
                                          <b-container fluid>
                                            <b-row class="mb-2">
                                              <b-col cols="auto" lg="3">
                                                <h6 class="st_color_gray_light st_none-none-base">
                                                  小計：
                                                </h6>
                                              </b-col>
                                              <b-col class="pl-0" cols="auto" lg="5">
                                                <h6 class="st_color_gray st_none-none-base">
                                                  {{ singleSubscribe === 'expired' ? '服務售價' : '訂閱金額' }}
                                                </h6>
                                              </b-col>
                                              <b-col class="text-right pl-0">
                                                <h6 class="st_color_gray_darker st_none-none-base">
                                                  ${{ channel.price }}<span v-if="month > 1"> x {{ month }}</span>
                                                </h6>
                                              </b-col>
                                            </b-row>

                                            <b-row v-if="couponList && couponList.length" class="mb-2">
                                              <b-col cols="auto" lg="3">
                                                <h6 class="st_none-none-base coupon__result-title-stuff" />
                                              </b-col>
                                              <b-col class="pl-0" cols="auto" lg="5">
                                                <h6 class="st_color_coupon d-flex align-items-center st_none-none-base">
                                                  <span
                                                    v-if="couponList[0].discount.calculationMethod !== 'thisOrder'"
                                                    class="coupon__state mr-1">
                                                    {{
                                                      couponList[0].discount.calculationMethod === 'firstMonth'
                                                        ? '首'
                                                        : '每'
                                                    }}{{
                                                      channel.unitWord && channel.unitWord !== ''
                                                        ? channel.unitWord
                                                        : '月'
                                                    }}
                                                  </span>
                                                  <span>優惠券折抵</span>
                                                </h6>
                                              </b-col>
                                              <b-col class="text-right pl-0">
                                                <h6 class="st_color_coupon st_none-none-base">
                                                  -${{ discount }}
                                                </h6>
                                              </b-col>
                                            </b-row>

                                            <b-row>
                                              <b-col cols="auto" lg="3">
                                                <h6 class="st_none-none-base coupon__result-title-stuff" />
                                              </b-col>
                                              <b-col class="pl-0" cols="auto" lg="5">
                                                <h6 class="st_color_gray st_none-none-base">
                                                  手續費
                                                </h6>
                                              </b-col>
                                              <b-col class="text-right pl-0">
                                                <h6 class="st_color_gray_darker st_none-none-base">
                                                  ${{ couponList.length ? discountPayFee : payFee }}
                                                </h6>
                                              </b-col>
                                            </b-row>
                                          </b-container>
                                        </b-row>
                                      </b-container>

                                      <b-container v-else class="px-0" fluid>
                                        <b-row class="align-items-center py-3 py-lg-0">
                                          <b-col class="text-center text-lg-left">
                                            <h5 class="st_color_gray_dark st_none-none-base">
                                              <template v-if="singleSubscribe === 'expired'">
                                                單次購買
                                              </template>
                                              <template v-else>
                                                {{ month }}
                                                {{
                                                  channel.unitWord && channel.unitWord !== ''
                                                    ? channel.unitWord
                                                    : '個月'
                                                }}
                                              </template>
                                            </h5>
                                          </b-col>
                                          <b-col class="text-right pl-0" cols="8">
                                            <h5 class="st_color_gray_darker">
                                              <span class="payChoose__amount__version_2__dollarsign">$</span><span
                                                class="payChoose__amount__version_2__price">{{
                                                couponList.length ? discountPayPrice : payPrice
                                              }}</span>
                                              <span class="st_none-none-base">新台幣</span>
                                            </h5>
                                          </b-col>
                                        </b-row>

                                        <hr class="border-bottom st_border_gray_lighter my-3">

                                        <b-row class="pb-3 pb-lg-0">
                                          <b-container fluid>
                                            <b-row class="mb-2">
                                              <b-col cols="auto" lg="3">
                                                <h6 class="st_color_gray_light st_none-none-base">
                                                  小計：
                                                </h6>
                                              </b-col>
                                              <b-col class="pl-0" cols="auto" lg="5">
                                                <h6 class="st_color_gray st_none-none-base">
                                                  {{ singleSubscribe === 'expired' ? '服務售價' : '訂閱金額' }}
                                                </h6>
                                              </b-col>
                                              <b-col class="text-right pl-0">
                                                <h6 class="st_color_gray_darker st_none-none-base">
                                                  ${{ channel.price }}<span v-if="month > 1"> x {{ month }}</span>
                                                </h6>
                                              </b-col>
                                            </b-row>

                                            <b-row v-if="couponList && couponList.length" class="mb-2">
                                              <b-col cols="auto" lg="3">
                                                <h6 class="st_none-none-base coupon__result-title-stuff" />
                                              </b-col>
                                              <b-col class="pl-0" cols="auto" lg="5">
                                                <h6 class="st_color_coupon d-flex align-items-center st_none-none-base">
                                                  <span
                                                    v-if="couponList[0].discount.calculationMethod !== 'thisOrder'"
                                                    class="coupon__state mr-1">
                                                    {{
                                                      couponList[0].discount.calculationMethod === 'firstMonth'
                                                        ? '首'
                                                        : '每'
                                                    }}{{
                                                      channel.unitWord && channel.unitWord !== ''
                                                        ? channel.unitWord
                                                        : '月'
                                                    }}
                                                  </span>
                                                  <span>優惠券折抵</span>
                                                </h6>
                                              </b-col>
                                              <b-col class="text-right pl-0">
                                                <h6 class="st_color_coupon st_none-none-base">
                                                  -${{ discount }}
                                                </h6>
                                              </b-col>
                                            </b-row>

                                            <b-row>
                                              <b-col cols="auto" lg="3">
                                                <h6 class="st_none-none-base coupon__result-title-stuff" />
                                              </b-col>
                                              <b-col class="pl-0" cols="auto" lg="5">
                                                <h6 class="st_color_gray st_none-none-base">
                                                  手續費
                                                </h6>
                                              </b-col>
                                              <b-col class="text-right pl-0">
                                                <h6 class="st_color_gray_darker st_none-none-base">
                                                  ${{ couponList.length ? discountPayFee : payFee }}
                                                </h6>
                                              </b-col>
                                            </b-row>
                                          </b-container>
                                        </b-row>
                                      </b-container>
                                    </b-col>
                                  </b-row>
                                </b-container>
                              </b-col>
                            </b-row>
                          </b-container>
                        </b-col>
                      </b-row>
                    </b-container>
                  </b-row>

                  <b-row class="my-4">
                    <b-col class="px-0" cols="12">
                      <hr class="st_border_gray_lighter">
                    </b-col>
                  </b-row>

                  <b-row class="receiptWrite">
                    <b-container fluid>
                      <b-row class="mb-3">
                        <b-col cols="12">
                          <h2 class="st_color_main_light st_none-none-big text-center receiptWrite__title">
                            3.填寫發票資訊
                          </h2>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-container fluid>
                          <b-row class="mb-4">
                            <b-col class="text-center" cols="12">
                              <md-radio v-model="formData.accType" class="st_radio" value="1">
                                個人戶發票
                              </md-radio>

                              <md-radio v-model="formData.accType" class="st_radio" value="2">
                                公司戶發票
                              </md-radio>
                            </b-col>
                          </b-row>

                          <b-row class="justify-content-center">
                            <b-col class="text-right receiptWrite__required" cols="12" lg="6">
                              <h6 class="st_color_gray_dark receiptWrite__text--smaller">
                                ＊表示必填
                              </h6>
                            </b-col>
                          </b-row>

                          <b-row class="justify-content-center">
                            <b-col class="receiptWrite__personal" cols="12" lg="6">
                              <b-container class="px-0" fluid>
                                <b-row v-if="formData.accType === '1'" class="py-3">
                                  <b-col class="mb-3">
                                    <h5 class="st_color_main_light receiptWrite__text--base">
                                      ＊ 訂閱者
                                    </h5>
                                  </b-col>

                                  <b-col class="pl-4" cols="12">
                                    <Input
                                      v-model="formData.name"
                                      :feedback="verification.feedback.name"
                                      :status="verification.state.name"
                                      class="my-0"
                                      inputClass="st_border_gray_lighter"
                                      placeholder="輸入您的姓名（必填）"
                                      type="text" />
                                  </b-col>
                                </b-row>

                                <b-row v-if="formData.accType === '2'" class="py-3">
                                  <b-col class="mb-3">
                                    <h5 class="st_color_main_light receiptWrite__text--base">
                                      ＊ 公司名稱
                                    </h5>
                                  </b-col>

                                  <b-col class="pl-4" cols="12">
                                    <Input
                                      v-model="formData.comName"
                                      :feedback="verification.feedback.comName"
                                      :status="verification.state.comName"
                                      class="my-0"
                                      inputClass="st_border_gray_lighter"
                                      placeholder="請輸入公司名稱（必填）"
                                      type="text" />
                                  </b-col>
                                </b-row>

                                <b-row v-if="formData.accType === '2'" class="py-3">
                                  <b-col class="mb-3">
                                    <h5 class="st_color_main_light receiptWrite__text--base">
                                      ＊ 公司統編
                                    </h5>
                                  </b-col>

                                  <b-col class="pl-4" cols="12">
                                    <Input
                                      v-model="formData.comId"
                                      :feedback="
                                        verification.state.comId.type
                                          ? verification.feedback.comId.type
                                          : verification.feedback.comId.limitation
                                      "
                                      :status="verification.state.comId.type || verification.state.comId.limitation"
                                      class="my-0"
                                      inputClass="st_border_gray_lighter"
                                      placeholder="例：12345678 （必填）"
                                      type="text" />
                                  </b-col>
                                </b-row>

                                <b-row class="py-3">
                                  <b-col class="mb-3">
                                    <h5 class="st_color_main_light receiptWrite__text--base">
                                      ＊ 聯絡信箱
                                      <span class="st_color_gray_dark receiptWrite__text--small ml-2">
                                        電子發票將寄送至您填寫的聯絡信箱
                                      </span>
                                    </h5>
                                  </b-col>

                                  <b-col class="pl-4" cols="12">
                                    <Input
                                      v-model="formData.email"
                                      :feedback="verification.feedback.email"
                                      :status="verification.state.email"
                                      class="my-0"
                                      inputClass="st_border_gray_lighter"
                                      placeholder="例：ScanTrader@gmail.com（必填）"
                                      type="text" />
                                  </b-col>
                                </b-row>

                                <b-row class="py-3">
                                  <b-col class="mb-3">
                                    <h5 class="st_color_main_light receiptWrite__text--base">
                                      ＊ 聯絡電話
                                    </h5>
                                  </b-col>

                                  <b-col class="pl-4" cols="12">
                                    <Input
                                      v-model="formData.tel"
                                      :feedback="verification.feedback.tel"
                                      :status="verification.state.tel"
                                      class="my-0"
                                      inputClass="st_border_gray_lighter"
                                      placeholder="請輸入聯絡電話（必填）"
                                      type="text" />
                                  </b-col>
                                </b-row>
                              </b-container>
                            </b-col>
                          </b-row>
                        </b-container>
                      </b-row>
                    </b-container>
                  </b-row>
                </b-container>
              </b-col>
            </b-row>

            <b-row>
              <b-col class="st_background_white" cols="12" lg="10" offset-lg="1">
                <b-container class="px-0 py-5" fluid>
                  <b-row class="mb-4">
                    <b-col cols="12" lg="8" offset-lg="2">
                      <client-only>
                        <b-form-group class="st_checkbox-group mb-2">
                          <b-form-checkbox v-model="agree" :uncheckedValue="false" :value="true">
                            <template v-if="singleSubscribe">
                              <span
                                v-if="pay === 'LINEPAY/PREAPPROVED' || pay === 'TAPPAY/PREAPPROVED'"
                                class="st_color_main_light confirm__text--base">
                                我了解本訂閱方案為單次購買項目，經付款完成後無法申請更換方案、取消訂閱及申請退費。<br>
                                並同意微股力 ScanTrader 進行本次付款的授權扣款。
                              </span>
                              <span
                                v-if="pay === 'ECPAY/CVS' || pay === 'ECPAY/ATM'"
                                class="st_color_main_light confirm__text--base">
                                我已詳閱並同意服務條款，本訂閱方案為單次購買項目，經付款完成後無法申請更換方案、取消訂閱及申請退費。
                              </span>
                            </template>
                            <template v-else>
                              <span
                                v-if="pay === 'LINEPAY/PREAPPROVED'"
                                class="st_color_main_light confirm__text--base">
                                我了解本訂閱方案預設為每月自動扣款續訂，且可以自行在下次扣款日前隨時取消續訂。<br>
                                {{
                                  trial && canTrial && channel.trial.time > 0
                                    ? ' 並同意 微股力 ScanTrader 於本次免費試閱申請綁定 LINE Pay，以及進行下次交易時的授權扣款。'
                                    : ' 並同意 微股力 ScanTrader 進行本次付款與下次交易時的授權扣款。'
                                }}
                              </span>
                              <span v-if="pay === 'TAPPAY/PREAPPROVED'" class="st_color_main_light confirm__text--base">
                                我了解本訂閱方案預設為每月自動扣款續訂，且可以自行在下次扣款日前隨時取消續訂。<br>
                                {{
                                  trial && canTrial && channel.trial.time > 0
                                    ? ' 並同意 微股力 ScanTrader 於本次免費試閱申請綁定信用卡，以及進行下次交易時的授權扣款。'
                                    : ' 並同意 微股力 ScanTrader 進行本次付款與下次交易時的授權扣款。'
                                }}
                              </span>
                              <span v-if="pay === 'ECPAY/CVS'" class="st_color_main_light confirm__text--base">
                                我已詳閱並同意服務條款，並理解超商付款為一次繳清，無法更換方案、取消訂閱及申請退費。
                              </span>
                              <span v-if="pay === 'ECPAY/ATM'" class="st_color_main_light confirm__text--base">
                                我已詳閱並同意服務條款，並理解 ATM 付款為一次繳清，無法更換方案、取消訂閱及申請退費。
                              </span>
                            </template>
                          </b-form-checkbox>
                        </b-form-group>
                      </client-only>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-container fluid>
                      <b-row class="mb-3">
                        <b-col class="text-center" cols="12">
                          <b-button
                            v-if="!isPayment"
                            :disabled="!agree || !showAction"
                            class="st_main_xl"
                            @click.prevent="onSubmit">
                            {{
                              (trial && canTrial && channel.trial.time > 0) ||
                                (discountTrial && discountTrial.price === 0)
                                ? `確認並前往 ${payment === 'LINEPAY' ? 'LINE Pay' : '信用卡授權'}`
                                : '確認並前往付款'
                            }}
                          </b-button>
                          <b-button
                            v-else
                            class="st_main_xl d-flex align-items-center justify-content-center mx-auto"
                            disabled>
                            <md-progress-spinner :mdDiameter="16" :mdStroke="2" mdMode="indeterminate" />
                            付款進行中...
                          </b-button>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col class="text-center" cols="12">
                          <h6 class="st_color_gray_dark confirm__text--small">
                            確認付款後即代表您已同意
                            <b-link :to="{ name: 'terms-of-service' }" target="_blank">
                              服務條款
                            </b-link>
                            及
                            <b-link :to="{ name: 'terms-of-pay' }" target="_blank">
                              付款政策
                            </b-link>
                          </h6>
                        </b-col>
                      </b-row>
                    </b-container>
                  </b-row>
                </b-container>
              </b-col>
            </b-row>

            <b-row class="mt-4">
              <b-container fluid>
                <b-row>
                  <b-col cols="12" lg="7" offset-lg="1">
                    <h6 class="st_color_gray_dark confirm__text--base mb-4">
                      訂閱須知
                    </h6>
                    <p class="st_color_gray_dark confirm__text--small">
                      訂閱內容不具標的推薦、操作建議之目的，請自負投資風險。<br>
                      創作者於平台提供之教學內容，主要是傳授股票線圖技術分析各種理論，或以技術理論之一般性分析或評介為授課內容，屬一般性的有價證券投資資訊之提供，並非進行個別股票之價值分析或推薦買賣。以技術理論之一般性分析或評介為授課內容。所引據大盤或個股歷史資料亦在印證其敘及理論，非為預測個股即時價格趨勢或給予投資建議。
                      <br><br>
                      本平台所提供之服務內容為數位內容，一經付款完成即可完整啟用。故不適用於消費者保護法第 19
                      條有關猶豫期間解除權等相關法令之規定，意即使用者同意其並無享有7天無條件退貨解約之權利。
                      <br><br>
                      請確認您目前購買的方案無誤，訂單一經成立後。除訂單類型為「月租訂閱」訂單，並使用 LINE Pay
                      或信用卡付款之用戶。本平台提供於訂購首 7 日內申請同一達人服務方案之轉換。（續訂訂單不適用）
                      <br><br>
                      若使用 LINE Pay
                      或信用卡付款之訂閱訂單成立後，將立即扣款支付當月的首次訂閱費。系統預設為「自動續訂」機制，往後每月訂閱扣款日將與首次扣款日相同。用戶可隨時於次月扣款日前自行「取消續訂」。<br>
                      例如：您於 2018/4/18 訂閱，下次扣款日為 2018/5/18。若遇到當月沒有的日期將往前一日。
                      <br><br>
                      此外因 ATM 與超商付款之訂閱訂單，訂單成立後您有三天的時間可做付款確認。故並不適用於 7
                      日內申請更換服務的範圍內。請用戶仔細確認您選擇的訂閱方案是否正確。
                      <br><br>
                      訂單類型為單次購買指定時間到期之服務項目，一經付款完成後無論付款方式皆無法申請更換方案、取消訂閱及申請退費。
                      <br><br>
                      若為本系統發生問題造成之用戶權益損害，退費產生之手續費將由平台自行負擔吸收。其餘退費將從退費款項中扣除手續費
                      15 元。
                      <br><br>
                      如因訂閱帳號遺失、信用卡失效或更換信用卡等個人因素導致訂閱權益受損，本平台將不予退費或補償。
                      <br><br>
                      發票一經開立後不可更改， 請確認資訊是否填寫正確。<br>
                      本平台不提供紙本發票，若您需要紙本發票請您至電子信箱收取電子發票通知信，將信內附件自行印出。<br>
                      若用戶發票中獎，本平台將透過訂閱時所填寫的 E-mail 主動通知用戶，如需兌獎請自行依信件內容指示前往
                      7-11 ibon 機台自行列印。
                      <br><br>
                      使用本服務訂閱時一次僅限使用一張優惠券，如有差額不會退還。若訂單有使用優惠券，退款時將不會退還您優惠券給您，將以實際付款金額做退款處理。
                      <br><br>
                      以上訂閱須知為付費政策之重點擷取，詳情請參考完整條款內容。
                    </p>
                  </b-col>
                </b-row>
              </b-container>
            </b-row>
          </b-container>
        </b-row>

        <b-row v-else class="mt-5">
          <b-col cols="12">
            <h2 class="login-notice-title st_color_main_light text-center">
              登入後，即可繼續訂閱服務！
            </h2>
            <div class="text-center mt-3">
              <b-button :href="user.loginUrl" class="btn-line-login" variant="none">
                <b-img alt="LINE Logo" src="/images/png_icon/xxxhdpi/btn_share_line.png" />
                用LINE帳號登入
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-row>

    <div v-show="false" ref="ecpay_html" class="ecpay_html" v-html="ecpayHtml" />
    <CouponSuggestion :channel="channel" />
  </b-container>
</template>

<script>
  import CartItemCard from '~/components/cards/CartItemCard'
  import CouponAnniversary from '~/components/views/CouponAnniversary'
  import CouponSuggestion from '~/components/modal/CouponSuggestion'
  import Input from '~/components/forms/Input'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    components: {
      Input,
      CartItemCard,
      CouponAnniversary,
      CouponSuggestion,
    },
    async asyncData ({
      app, store, params, redirect,
    }) {
      if (!app.$userCheck.are(['service'])) {
        redirect(app.$userRoute({ name: 'u-uid' }))
      }
      const options = {
        identity: params.pid,
      }
      const channel = await store.dispatch('api/channel/getChannel', options)
      !channel.identity && redirect(app.$userRoute({ name: 'u-uid' }))

      return {
        channel,
      }
    },
    head () {
      if (!this.user.user_info.service) {
        return {}
      }
      return {
        title: `服務項目 - ${this.channel.title}`,
        meta:  [
          {
            hid:     'title',
            name:    'title',
            content: `服務項目 - ${this.channel.title}${process.env.SEO.titleSplit}`,
          },
          {
            hid:      'og:title',
            property: 'og:title',
            content:  `服務項目 - ${this.channel.title}${process.env.SEO.titleSplit}`,
          },
          {
            hid:     'description',
            name:    'description',
            content: this.$utils.filterAllHtmlTags(this.channel.content, 150),
          },
          {
            hid:      'og:description',
            property: 'og:description',
            content:  this.$utils.filterAllHtmlTags(this.channel.content, 150),
          },
          {
            hid:     'image',
            name:    'image',
            content: this.channel.cover,
          },
          {
            hid:      'og:image',
            property: 'og:image',
            content:  this.channel.cover,
          },
        ],
      }
    },
    data () {
      return {
        loading:  true,
        formData: {
          accType: '1',
          name:    null,
          tel:     null,
          email:   null,
          comName: null,
          comId:   null,
        },
        canTrial: false,
        trial:    false,
        pay:      'LINEPAY/PREAPPROVED',
        month:    1,
        free:     {
          onShowDetail: false,
        },
        coupon:               [],
        couponInput:          '',
        couponPlaceholder:    '輸入優惠券代碼',
        couponState:          null,
        couponList:           [],
        couponFeedback:       '',
        discount:             0,
        couponDisabled:       false,
        couponButtonDisabled: false,
        discountTrial:        null,
        discountedPrice:      0,
        discountAmount:       0,
        discountPayPrice:     0,
        discountPayFee:       0,
        agree:                false,
        subscription:         null,
        ecpayHtml:            '',
        card:                 {
          type:   'none',
          number: '',
          expiry: '',
          ccv:    '',
        },
        cards:          null,
        useNewCard:     true,
        paymentCard:    null,
        isPayment:      false,
        couponChecking: false,
      }
    },
    computed: {
      ...mapGetters(['user', 'siteSetting']),
      anniversaryIdentity () {
        // current expert account identity
        return this.user.user_info.service.account.identity
      },
      payment () {
        return this.pay.split('/')[0]
      },
      payType () {
        return this.pay.split('/')[1]
      },
      payFee () {
        return this.channel.priceTable[this.pay].find(data => Number(data.month) === this.month).fee || 0
      },
      payPrice () {
        return this.channel.priceTable[this.pay].find(data => Number(data.month) === this.month).total || 0
      },
      showAction () {
        const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        const colIdRegex = /^\d{8}$/
        if (!this.useNewCard && !this.paymentCard) {
          return false
        }
        if (this.pay === 'TAPPAY/PREAPPROVED' && this.useNewCard) {
          if (!this.cardNumberState || !this.cardExpiryState || !this.cardCcvState) {
            return false
          }
        }
        if (this.formData.accType === '1') {
          return (
            this.formData.name !== ''
            && this.formData.tel !== ''
            && this.formData.email !== ''
            && emailRegex.test(this.formData.email)
          )
        } else if (this.formData.accType === '2') {
          return (
            this.formData.comName !== ''
            && this.formData.comId !== ''
            && colIdRegex.test(this.formData.comId)
            && this.formData.email !== ''
            && emailRegex.test(this.formData.email)
            && this.formData.tel !== ''
          )
        }
        return false
      },
      verification () {
        return {
          state: {
            name:  this.formData.name === null || this.formData.name.length ? '' : 'is-invalid',
            email:
              this.formData.email === null
              || /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                this.formData.email,
              )
                ? ''
                : 'is-invalid',
            tel:     this.formData.tel === null || /^\d{7,}$/.test(this.formData.tel) ? '' : 'is-invalid',
            comName: this.formData.comName === null || this.formData.comName.length ? '' : 'is-invalid',
            comId:   {
              type:       this.formData.comId === null || /^\d+$/.test(this.formData.comId) ? '' : 'is-invalid',
              limitation: this.formData.comId === null || /^\d{8}$/.test(this.formData.comId) ? '' : 'is-invalid',
            },
          },
          feedback: {
            name:  '格式或字數不符',
            email: '電子郵件格式錯誤',
            tel:   '請填寫正確的聯絡電話',
            comId: {
              type:       '公司編號僅能輸入數字',
              limitation: '字數不符',
            },
            comName: '格式或字數不符',
          },
        }
      },
      singleSubscribe () {
        if (this.channel && (this.channel.autoRenewal === -1 || this.channel.convertAutoRenewalToSingle)) {
          return this.channel.autoRenewal === -1 ? 'expired' : 'month'
        }
        return false
      },
      cardNumber () {
        let number = ''
        if (
          this.card.type !== 'none'
          && ((this.card.type === 'amex' && this.card.number.length === 17)
            || (this.card.type !== 'amex' && this.card.number.length === 19))
        ) {
          number = this.card.number.split('-').join('')
        }
        return number
      },
      cardMonth () {
        let month = ''
        if (this.card.expiry !== '' && _.get(this.card, 'expiry.length', 0) > 1) {
          month = this.card.expiry.split('/')[0]
        }
        return month
      },
      cardYear () {
        let year = ''
        if (this.card.expiry !== '' && _.get(this.card, 'expiry.length', 0) > 4) {
          year = this.card.expiry.split('/')[1]
        }
        return year
      },
      cardNumberState () {
        let state = null
        if (this.cardNumber !== '') {
          const type = TPDirect.validate.cardType(this.cardNumber)
          state = TPDirect.validate.cardNumber(this.cardNumber, type)
        }
        return state
      },
      cardExpiryState () {
        let state = null
        if (this.cardMonth !== '' && this.cardYear !== '') {
          state = TPDirect.validate.expiry(this.cardMonth, this.cardYear)
        }
        return state
      },
      cardCcvState () {
        let state = null
        if (this.cardNumber !== '' && this.card.ccv !== '') {
          const type = TPDirect.validate.cardType(this.cardNumber)
          if ((type === 'AMEX' && this.card.ccv.length === 4) || (type !== 'AMEX' && this.card.ccv.length === 3)) {
            state = TPDirect.validate.ccv(this.card.ccv, type)
          }
        } else if (this.cardNumber === '' && this.card.ccv.length === 3) {
          state = false
        }
        return state
      },
      cardListLinePay () {
        const cards = null
        if (this.cards && this.cards.length) {
          return this.cards.filter(card => card.payment === 'LINEPAY')
        }
        return cards
      },
      cardListTapPay () {
        const cards = null
        if (this.cards && this.cards.length) {
          return this.cards.filter(card => card.payment === 'TAPPAY')
        }
        return cards
      },
    },
    watch: {
      'formData.name':    'replaceAllEmoji',
      'formData.tel':     'replaceAllEmoji',
      'formData.email':   ['replaceAllEmoji', 'replaceEmail'],
      'formData.comName': 'replaceAllEmoji',
      'formData.comId':   'replaceAllEmoji',
      trial:              'checkTrialRule',
      useNewCard:         'revertUseNewCard',
      'card.number':      'replaceCardNumber',
      'card.expiry':      'replaceCardExpiry',
      'card.ccv':         'replaceCardCcv',
      month:              'checkCouponWhenSwitch',
      pay:                ['revertMonth', 'checkCouponWhenSwitch'],
    },
    methods: {
      ...mapActions('api/order', ['createOrder']),
      ...mapActions('api/subscription', ['getSubscription']),
      ...mapActions('api/history', ['createHistory']),
      ...mapActions('api/couponType', ['getCouponTypeCodesCheck']),
      ...mapActions('api/card', ['getCards']),
      checkCouponWhenSwitch () {
        if (this.couponList.length && this.couponList[0].code) {
          const { code } = this.couponList[0]
          this.removeCoupon(code)
          this.couponInput = code
          this.checkCoupon()
        }
      },
      checkCoupon () {
        if (this.couponInput && !this.couponChecking) {
          this.couponInput = this.couponInput.replace(/\s+/g, '')
          this.couponChecking = true
          this.trial = false
          const option = {
            payment:    this.payment,
            payType:    this.payType,
            kind:       'channel',
            index:      this.channel.identity,
            codes:      this.couponInput,
            totalMonth: this.month,
          }
          this.getCouponTypeCodesCheck(option).then(data => {
            if (!data.error) {
              this.coupon.push(this.couponInput)
              this.couponInput = ''
              this.couponDisabled = true
              this.couponButtonDisabled = true
              this.couponState = ''
              this.couponFeedback = ''
              this.couponPlaceholder = '已兌換'
              if (data.trial.time > 0) {
                this.discountTrial = data.trial
              }
              this.couponList.push(data.results[0])
              this.discount = data.discounts
              this.discountedPrice = data.discountedPrice
              this.discountAmount = data.amount || 0
              this.discountPayPrice = data.payPrice || 0
              this.discountPayFee = data.fee || 0
            } else if (data.status === 429) {
              this.couponState = 'is-warning'
              this.couponFeedback = '驗證次數過多，請稍後再試'
            } else {
              this.couponState = 'is-invalid'
              this.couponFeedback = '優惠券無法使用'
            }
            this.couponChecking = false
          })
        }
      },
      removeCoupon (code) {
        this.coupon = this.coupon.filter(couponOne => couponOne !== code)
        this.couponList = this.couponList.filter(couponOne => couponOne.code !== code)
        if (this.coupon.length === 0) {
          this.discount = 0
          this.discountedPrice = 0
          this.discountAmount = 0
          this.discountPayPrice = 0
          this.discountPayFee = 0
          this.couponInput = ''
          this.couponDisabled = false
          this.couponButtonDisabled = false
          this.couponState = ''
          this.couponFeedback = ''
          this.couponPlaceholder = '輸入優惠券代碼'
          this.discountTrial = null
        }
      },
      convertAutoRenewal (autoRenewal, convertAutoRenewalToSingle) {
        let text = '月'
        switch (autoRenewal) {
          case 3:
            text = '季'
            break
          case 6:
            text = '半年'
            break
          case 12:
            text = '年'
            break
          case -1:
            text = '次'
            break
        }
        if (convertAutoRenewalToSingle) {
          text = '次'
        }
        return text
      },
      checkTrialRule () {
        this.coupon.map(this.removeCoupon) // reset when coupon length equal 0

        if (this.trial) {
          this.couponDisabled = true
          this.couponButtonDisabled = true
          this.couponPlaceholder = '免費試閱無法使用優惠卷'
        } else {
          this.couponDisabled = false
          this.couponButtonDisabled = false
          this.couponPlaceholder = '輸入優惠券代碼'
        }
      },
      revertMonth () {
        if (this.checkPayDisable(this.pay)) {
          this.pay = ['LINEPAY/PREAPPROVED', 'TAPPAY/PREAPPROVED', 'ECPAY/ATM', 'ECPAY/CVS'].find(
            pay => !this.checkPayDisable(pay),
          )
          return
        }
        const preapprovedMonth = this.channel.autoRenewal > 1 ? this.channel.autoRenewal : 1
        this.month = this.payType === 'PREAPPROVED'
          ? preapprovedMonth
          : [1, 3, 6, 12].find(month => !this.checkMonthDisable(month)) || 0
        this.trial = this.payType === 'PREAPPROVED' && this.canTrial
        this.paymentCard = null
        this.useNewCard = true
        switch (this.payment) {
          case 'LINEPAY':
            if (this.cardListLinePay && this.cardListLinePay.length) {
              this.useNewCard = false
            }
            break
          case 'TAPPAY':
            if (this.cardListTapPay && this.cardListTapPay.length) {
              this.useNewCard = false
            }
            break
        }
      },
      revertUseNewCard () {
        this.paymentCard = null
      },
      checkMonthDisable (month) {
        if (
          this.channel.unavaliableBuyOption
          && this.channel.unavaliableBuyOption.months
          && this.channel.unavaliableBuyOption.months.length
          && this.channel.unavaliableBuyOption.months.includes(month)
        ) {
          return true
        }
        const priceTable = this.channel.priceTable[this.pay]
        if (this.payment === 'ECPAY' && this.payType === 'CVS') {
          return priceTable.find(data => data.month === month).total > 20000
        }
        return false
      },
      checkMonthDisablePrice (month) {
        const priceTable = this.channel.priceTable[this.pay]
        if (this.payment === 'ECPAY' && this.payType === 'CVS') {
          return priceTable.find(data => data.month === month).total > 20000
        }
        return false
      },
      checkPayDisable (payment) {
        return (
          (this.channel.unavaliableBuyOption
            && this.channel.unavaliableBuyOption.paymentMethod
            && this.channel.unavaliableBuyOption.paymentMethod.length
            && this.channel.unavaliableBuyOption.paymentMethod.includes(payment))
          || false
        )
      },
      replaceAllEmoji () {
        this.formData.name = this.formData.name === null ? this.formData.name : this.$utils.replaceEmoji(this.formData.name)
        this.formData.tel = this.formData.tel === null ? this.formData.tel : this.$utils.replaceEmoji(this.formData.tel)
        this.formData.email = this.formData.email === null ? this.formData.email : this.$utils.replaceEmoji(this.formData.email)
        this.formData.comName = this.formData.comName === null
          ? this.formData.comName
          : this.$utils.replaceEmoji(this.formData.comName).replace(' ', '')
        this.formData.comId = this.formData.comId === null
          ? this.formData.comId
          : this.$utils.replaceEmoji(this.formData.comId).replace(' ', '')
      },
      replaceCardNumber () {
        if (this.card.number !== '') {
          const number = this.card.number
            .split('-')
            .join('')
            .replace(/[^0-9.]/g, '') || ''
          let type = 'none'
          switch (TPDirect.validate.cardType(number)) {
            case 'VISA':
              type = 'visa'
              break
            case 'MASTERCARD':
              type = 'master'
              break
            case 'JCB':
              type = 'jcb'
              break
            case 'AMEX':
              type = 'amex'
              break
          }
          this.card.type = type
          if (type === 'amex') {
            const numberSplit = number.split('')
            if (numberSplit[11]) {
              numberSplit.splice(11, 0, '-')
            }
            if (numberSplit[5]) {
              numberSplit.splice(5, 0, '-')
            }
            this.card.number = numberSplit.join('')
          } else {
            this.card.number = (number.match(/.{1,4}/g) || []).join('-')
          }
        } else {
          this.card.type = 'none'
        }
      },
      replaceCardExpiry () {
        if (this.card.expiry && this.card.expiry !== '') {
          let expiry = this.card.expiry
            .split('/')
            .join('')
            .replace(/[^0-9.]/g, '') || ''
          if (this.card.expiry.length === 2 && this.cardMonth > 12) {
            expiry = `0${this.card.expiry}`
          }
          if (expiry.length > 2) {
            expiry = expiry.match(/.{1,2}/g).join('/')
          }
          this.card.expiry = expiry || null
        }
      },
      replaceCardCcv () {
        this.card.ccv = this.card.ccv.replace(/[^0-9.]/g, '') || ''
      },
      replaceEmail () {
        if (!this.formData.email) return
        const newEmail = this.formData.email.replaceAll('＠', '@').replace(/\s+/g, '')
        if (newEmail !== this.formData.email) this.formData.email = newEmail
      },
      getCardType (cardType) {
        let type = 'none'
        switch (cardType) {
          case 'VISA':
            type = 'visa'
            break
          case 'MASTER':
            type = 'master'
            break
          case 'JCB':
            type = 'jcb'
            break
          case 'AMEX':
            type = 'amex'
            break
        }
        return type
      },
      async loadCardList () {
        this.cards = null
        const option = {
          isValid:   true,
          accountId: this.user.my_info.identity,
        }
        await this.getCards(option).then(data => {
          if (!data.error) {
            this.cards = data.cards
          }
        })
      },
      showMsgBox (message) {
        return this.$bvModal.msgBoxOk(message, {
          size:            'sm',
          buttonSize:      'sm',
          okVariant:       'success',
          okTitle:         '確定',
          footerClass:     'p-2 border-0',
          hideHeaderClose: false,
          centered:        true,
        })
      },
      onSubmit () {
        this.isPayment = true
        this.ecpayHtml = ''
        const { protocol } = window.location
        const domain = window.location.href.split('/')[2]
        const callback = `${protocol}//${domain}${process.env.basePath}u/${this.$route.params.uid}/service/product/${this.$route.params.pid}`

        const order = {
          payment:      this.payment,
          payType:      this.payType,
          totalMonth:   this.channel.autoRenewal === -1 ? -1 : this.month, // 當channel.autoRenewal是-1時，代表這是指定到期時間的訂閱
          AccountId:    this.user.my_info.identity,
          ChannelId:    this.channel.identity,
          callback:     callback,
          contactEmail: this.formData.email,
          contactPhone: this.formData.tel,
          trial:        this.channel.trial.time > 0 && this.canTrial && this.trial,
        }

        // 判斷個人訂單還是公司訂單
        if (this.formData.accType === '1') {
          order.realName = this.formData.name
        } else {
          order.companyName = this.formData.comName
          order.taxId = this.formData.comId
        }

        if (!this.trial && this.coupon.length) {
          order.couponCodes = this.coupon
        }

        const useCardCheck = !!(
          !this.useNewCard
          && (this.payment === 'LINEPAY' || this.payment === 'TAPPAY')
          && this.paymentCard
        )
        if (useCardCheck) {
          order.cardId = this.paymentCard.id
        }

        if (this.pay === 'TAPPAY/PREAPPROVED' && this.useNewCard) {
          TPDirect.card.createToken(this.cardNumber, this.cardMonth, this.cardYear, this.card.ccv, res => {
            if (res.status === 0) {
              order.prime = res.card.prime
              this.createOrder(order).then(data => {
                if (!data.error) {
                  if (data.url) {
                    window.location.href = data.url
                  } else if (data.data) {
                    window.location.href = data.data.payment_url
                  } else {
                    this.isPayment = false
                    this.showMsgBox('信用卡付款錯誤，請洽客服人員')
                  }
                } else {
                  this.isPayment = false
                  this.showMsgBox('信用卡付款錯誤，請洽客服人員')
                }
              })
            } else {
              this.isPayment = false
              this.showMsgBox('信用卡付款錯誤，請洽客服人員')
            }
          })
        } else {
          this.createOrder(order).then(data => {
            if (data.error && data.code === '-25991') {
              // 指定方案加入限定購買條件：
              // 某達人希望新開的方案(簡稱 B 方案)可加入限制，需有訂過指定方案(簡稱 A 方案)者才可訂閱該方案。
              // 若沒有訂閱 A方案 就想訂閱 B方案，表單送出後，後端會回傳以下錯誤訊息
              // const errorRes = {
              //   code:   '-25991',
              //   detail: 'No Valid PreSubscription',
              //   error:  true,
              //   status: 400,
              //   title:  'Requirements not met',
              // }
              this.isPayment = false
              this.showMsgBox('需先訂閱指定方案，才能訂閱此方案')
              return
            }
            if (useCardCheck) {
              if (data.url) {
                window.location.href = data.url
              } else {
                this.isPayment = false
                this.showMsgBox('卡片付款錯誤，請洽客服人員')
              }
            } else {
              switch (this.payment) {
                case 'LINEPAY':
                  if (data.returnCode !== '0000') {
                    this.isPayment = false
                    this.showMsgBox('LINE Pay 錯誤，請洽客服人員')
                  } else {
                    window.location.href = data.info.paymentUrl.web
                  }
                  break
                case 'ECPAY':
                  if (!data.error) {
                    this.ecpayHtml = data.result
                    const checkEcpayForm = setInterval(() => {
                      const form = this.$refs.ecpay_html.getElementsByTagName('form')
                      if (form.length > 0) {
                        clearInterval(checkEcpayForm)
                        form[0].submit()
                      }
                    }, 100)
                  } else {
                    this.isPayment = false
                    this.showMsgBox('EC PAY 錯誤，請洽客服人員')
                  }
                  break
              }
            }
          })
        }
      },
    },
    async created () {
      if (this.user.serial !== 0) {
        await this.loadCardList()
        if (this.channel.trial.time > 0) {
          const trailSubscriptionOption = {
            account:     this.user.my_info.identity,
            channel:     this.$route.params.pid,
            trial:       1,
            withDeleted: true,
          }
          await this.getSubscription(trailSubscriptionOption).then(subscription => {
            this.canTrial = subscription.error || subscription.identity === null
            this.trial = this.canTrial
          })
        }
        this.revertMonth()
        this.checkTrialRule()
        const subscriptionOption = {
          account: this.user.my_info.identity,
          channel: this.$route.params.pid,
          expired: 'now',
        }
        await this.getSubscription(subscriptionOption).then(subscription => {
          this.subscription = !subscription.error ? subscription.identity : null
          this.loading = false
        })
      } else {
        this.loading = false
      }
    },
    mounted () {
      if (this.siteSetting.TPDirect && TPDirect && !TPDirect.appID) {
        TPDirect.setupSDK(
          this.siteSetting.TPDirect.appID,
          this.siteSetting.TPDirect.appIDappKey,
          this.siteSetting.TPDirect.serverType,
        )
      }
      const historyOption = {
        account:     this.user.my_info.identity || 0,
        kind:        'channel',
        index:       this.channel.identity,
        fingerprint: this.user.fingerprint,
      }
      this.createHistory(historyOption)
    },
  }
</script>

<style lang="scss" scoped>
.purchaseInfo {
  margin: 0 -15px;

  &__title {
    padding: 20px 0;

    @include media-breakpoint-up(md) {
      padding: 60px 0 40px 0;
    }
  }

  &__detail {
    background-color: rgba($st_color_gray_lighter, 0.3);
  }

  &__title,
  &__detail {
    margin: 0 auto;

    @include media-breakpoint-up(md) {
      max-width: 800px;
    }

    @include media-breakpoint-up(xl) {
      max-width: 950px;
    }
  }
}

p,
h2,
h3,
h5,
h6 {
  margin: 0;
  font-weight: normal;
}

.payment__amount {
  font-size: 28px;
}

.loading__icon {
  font-size: 26px;
}

.coupon__icon {
  font-size: 20px;
}

.payChoose__text--big {
  font-size: $st_font-size-big;
}

.trial__text--bigger,
.payment__amount__desktop {
  font-size: $st_font-size-bigger;
}

.trial__text--base,
.payChoose__text--base,
.receiptWrite__text--base,
.confirm__text--base {
  font-size: $st_font-size-base;
}

.trial__text--small,
.payChoose__text--small,
.receiptWrite__text--small,
.confirm__text--small {
  font-size: $st_font-size-small;
}

.trial__text--smaller,
.payChoose__text--smaller,
.receiptWrite__text--smaller {
  font-size: $st_font-size-smaller;
}

.payment--border {
  border-top: 2px solid $st_color_gray_lighter;
}

.max-width-265px {
  max-width: 265px;
}

$line_color_main: #00b833;

$st_color_coupon: #a600ff;

.st_color_coupon {
  color: $st_color_coupon;
}

.border-width-2px {
  @important {
    border-width: 2px;
  }
}

.st_border_gray_lighter {
  @important {
    border-color: $st_color_gray_lighter;
  }
}

.question-mark {
  color: $st_color_white;
  background-color: $st_color_gray_light;
  width: 14px;
  height: 14px;
  display: inline-block;
  font-size: 12px;
  font-weight: normal;
  line-height: 14px;
  text-align: center;
  border-radius: 50%;
  margin-left: 5px;
  cursor: pointer;
}

.line-height-1_2rem {
  line-height: 1.2rem;
}

.login-notice-title {
  @include media-breakpoint-down(md) {
    font-size: 18px;
  }

  font-size: 24px;
}

.btn-line-login {
  padding: 0 16px 0 2px;
  border-radius: 8px;
  color: $st_color_white;
  background-color: $line_color_main;
  border-color: $line_color_main;

  img {
    width: 40px;
    border-right: 1px solid #009800;
    margin-right: 16px;
  }
}

.trial-subscription {
  .block {
    position: relative;

    @important {
      border-color: $st_color_gray_lighter;
    }

    .title-text {
      color: $st_color_main_light;
      font-weight: 500;
    }

    .notice {
      position: absolute;
      z-index: 9;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: none;
      background-color: rgba($st_color_gray_darker, 0.7);
      justify-content: center;
      align-items: center;
    }
  }

  &.active {
    .block {
      @important {
        border-color: $st_color_sub;
      }

      .title-text {
        color: $st_color_sub;
        font-weight: normal;
      }
    }
  }

  &.disabled {
    .block {
      .notice {
        display: flex;
      }
    }
  }
}

.trial-subscription-mobile {
  .block {
    @important {
      border-color: $st_color_gray_lighter;
    }

    .title {
      background-color: $st_color_gray_lighter;

      .title-text {
        color: $st_color_main_light;
      }
    }

    .des {
      position: relative;

      .des-notice {
        position: absolute;
        z-index: 9;
        display: none;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }

  &.active {
    .block {
      @important {
        border-color: $st_color_sub;
      }

      .title {
        background-color: $st_color_sub;

        .title-text {
          color: $st_color_white;
        }
      }
    }
  }

  &.disabled {
    .block {
      .title {
        .title-text {
          color: $st_color_gray;
        }
      }

      .des {
        background-color: rgba($st_color_gray_darker, 0.7);
        display: flex;
        justify-content: center;
        align-items: center;

        .des-notice {
          display: block;
        }
      }
    }
  }
}

.creditCard {
  &__block {
    background: rgba(236, 238, 239, 0.3);

    @include media-breakpoint-up(lg) {
      padding: 32px;
    }
  }

  &__inside {
    max-width: 500px;
  }

  &__input {
    width: 100%;
    height: 100%;
    border: none;
    padding: 0 0.5rem;
    color: $st_color_gray_darker;
    box-shadow: none;
    outline: none;

    &::placeholder {
      color: $st_color_gray_light;
    }
  }

  &__number {
    border-radius: 2px;
    background-color: $st_color_white;
    border: solid 2px $st_color_gray_lighter;
    height: 45px;
    box-sizing: border-box;

    &__icon {
      margin-top: -4px;
    }
  }

  &__expiry {
    border-radius: 2px;
    background-color: $st_color_white;
    border: solid 2px $st_color_gray_lighter;
    height: 45px;
    box-sizing: border-box;
  }

  &__ccv {
    border-radius: 2px;
    background-color: $st_color_white;
    border: solid 2px $st_color_gray_lighter;
    height: 45px;
    box-sizing: border-box;
  }

  &__state {
    &--true {
      border-color: $st_color_success;
    }

    &--false {
      border-color: $st_color_error;
    }
  }
}

.coupon {
  &__state {
    display: inline-block;
    border-radius: 2px;
    border: solid 1px #ce31f9;
    color: #ce31f9;
    font-size: 12px;
    font-weight: normal;
    padding-left: 1px;
    padding-right: 1px;
    line-height: 1.71em;
  }

  &__result {
    &-title-stuff {
      min-width: 3em;
    }
  }

  &__border--mobile {
    @include media-breakpoint-down(lg) {
      margin-left: -15px;
      margin-right: -15px;
    }
  }
}

@include media-breakpoint-down(md) {
  .st_background_white_down_md {
    background-color: $st_color_white;
  }
}

.text-overflow-1-line {
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-break: break-all;
  white-space: initial;
  line-height: initial;
}

/deep/ {
  .md-progress-spinner.md-theme-default {
    margin-right: 6px;

    .md-progress-spinner-circle {
      stroke: $st_color_gray;
    }
  }

  .multiselect__tags {
    cursor: default;
  }

  .multiselect__content-wrapper {
    overflow-x: hidden;
    z-index: 100;
  }

  .multiselect--disabled .multiselect__select {
    display: none;
  }

  .multiselect__option {
    color: $st_color_gray_darker;

    &--highlight {
      background: #e1e1e1;
      color: $st_color_gray_darker;

      &.multiselect__option--selected {
        background: #f3f3f3;
        color: $st_color_gray_darker;
      }
    }
  }
}

.payChoose {
  &__coupon,
  &__amount {
    &__version_1 {
      &__dollarsign {
        font-size: $st_font-size-bigger;
        line-height: 10px;
      }

      &__price {
        font-size: 28px;
        line-height: 14px;
      }
    }

    &__version_2 {
      &__dollarsign {
        font-size: $st_font-size-big;
        line-height: 9px;
      }

      &__price {
        font-size: 28px;
        line-height: 14px;
      }
    }
  }
}

@include media-breakpoint-up(lg) {
  .payChoose {
    &__way__title {
      background: transparent;

      h5 {
        font-size: $st_font-size-big;
      }
    }

    &__period {
      border-top: 2px solid $st_color_gray_lighter;

      &__title {
        background: transparent;

        h5 {
          font-size: $st_font-size-big;
          margin-left: 24px;
        }
      }
    }

    &__coupon,
    &__amount {
      border-top: 2px solid $st_color_gray_lighter;

      &__title {
        background: transparent;

        h5 {
          font-size: $st_font-size-big;
          margin-left: 15px;
        }
      }

      &__input {
        @important {
          justify-content: flex-start;
        }
      }

      &__version_1 {
        &__price {
          font-size: $st_font-size-bigger;
          line-height: 10px;
        }
      }

      &__version_2 {
        &__dollarsign,
        &__price {
          font-size: $st_font-size-biggest;
          line-height: 12px;
        }
      }
    }
  }

  .receiptWrite {
    &__title {
      font-size: $st_font-size-biggest;
    }

    &__required {
      @important {
        text-align: left;
      }
    }

    &__personal {
      border: 1px solid $st_color_gray_lighter;
      margin-top: 8px;
      padding: 10px 31px 20px 20px;
    }
  }
}
</style>
